<template>
  <div
    class="ui-search-fixed"
    :class="[isScroll?'ui-white':'']"
  >
    <div
      class="ui-search"
      :class="[isScroll?'ui-searchStopBg':'ui-searchBg']"
      @click="toSearch"
      :clstag="'jr|keycount|8530052_search|tosearch'"
    >
      <div class="ui-first">
        <img src="https://img12.360buyimg.com/jrpmobile/jfs/t1/16682/26/2982/1022/5c22271aE9d99f321/170c2e53dbd638dd.png">
      </div>
      <div class="ui-second">
      </div>
      <div class="ui-third">
        <img src="//img12.360buyimg.com/jrpmobile/jfs/t1/17999/24/3827/866/5c2c9c5aE474fa60b/0b95f2a7b18b98d3.png" />
      </div>
      <div class="ui-forth">
        <!-- <input
          :placeholder="placeHolder"
          disabled
        /> -->
        <div>{{placeHolder}}</div>
      </div>
    </div>

  </div>
</template>
<script>
const staticDataSource = (window['data_source_100001014'] && window['data_source_100001014']) || {};

export default {
  name: 'Tip',
  data() {
    return {
      showTip: true,
      placeHolder: staticDataSource.searchDefaultPlaceholder || ''
    };
  },
  components: {},
  props: {
    content: {
      type: String,
      default: ''
    },
    isScroll: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toSearch() {
      //   this.$router.push({
      //     path: '/category',
      //     query: {
      //       mini_search: 1
      //     }
      //   });
      let word = encodeURIComponent(staticDataSource.searchDefaultPlaceholder) || '手机';
      window.location.href = `https://jddx.jd.com/m/search/index.html?word=${word}&source=mall&from=mx`;
    }
  },
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.ui-search-fixed {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100%;
  height: $rem96;
  padding: $rem20 $rem32;
  .ui-search {
    // opacity: 0.6;
    padding-left: $rem30;
    border-radius: $rem34;

    width: 100%;
    height: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    input {
      width: 100%;
    }
    img {
      height: $rem28;
    }
    .ui-first {
      padding-right: $rem20;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .ui-second {
      // background: #d8d8d8;
      border-radius: $rem1;
      height: $rem32;
      border-right: $rem1 solid #cccccc;
    }
    .ui-third {
      padding-left: $rem20;
      display: flex;
      align-items: center;
    }
    .ui-forth {
      height: $rem40;
      line-height: $rem40;
      padding-left: $rem12;
      background: none;
      div {
        font-family: PingFangSC-Regular;
        color: #666;
        letter-spacing: 0;
        height: 100%;
        // line-height: $rem24;
        font-size: $rem24;
      }
    }
    input {
      height: $rem32;
      // line-height: $rem28;
      font-size: $rem24;
      background: none;
    }
    input::placeholder {
      appearance: none;
      font-family: PingFangSC-Regular;
      color: #999;
      letter-spacing: 0;
      height: 100%;
      // line-height: $rem24;
      font-size: $rem24;
    }
  }
  .ui-searchBg {
    background: rgba(255, 255, 255, 0.85);
  }
  .ui-searchStopBg {
    background: rgba(242, 242, 242, 0.85);
  }
}
.ui-white {
  background: #ffffff;
}
</style>
